export const actionTypes = {
  TEMPORARY_ABILITATIONS_FETCH_REQUEST: "TEMPORARY_ABILITATIONS_FETCH_REQUEST",
  TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS:
    "TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS",
  TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE:
    "TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE",
  SET_SELECTED_TEMPORARY_ABILITATION: "SET_SELECTED_TEMPORARY_ABILITATION",
  SEND_TEMPORARY_ABILITATION_REQUEST_ACTION:
    "SEND_TEMPORARY_ABILITATION_REQUEST_ACTION",
  SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS:
    "SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS",
  SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE:
    "SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE",
  GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION:
    "GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION",
  GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS:
    "GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS",
  GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE:
    "GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE",
  SET_FIELD_VALUE_SELECTED_TEMPORARY_ABILITATION:
    "SET_FIELD_VALUE_SELECTED_TEMPORARY_ABILITATION",
  RESET_STATE_TEMPORARY_ABILITATIONS: "RESET_STATE_TEMPORARY_ABILITATIONS",
  GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST:
    "GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST",
  GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST_SUCCESS:
    "GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST_SUCCESS",
  GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST_FAILURE:
    "GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST_FAILURE",

  CHECK_REQUIREMENT_ENTITLEMENTS: "CHECK_REQUIREMENT_ENTITLEMENTS",
  CHECK_REQUIREMENT_ENTITLEMENTS_SUCCESS:
    "CHECK_REQUIREMENT_ENTITLEMENTS_SUCCESS",
  CHECK_REQUIREMENT_ENTITLEMENTS_FAILURE:
    "CHECK_REQUIREMENT_ENTITLEMENTS_FAILURE",

  GET_EMERGENCY_CHECK_REQUEST: "GET_EMERGENCY_CHECK_REQUEST",
  GET_EMERGENCY_CHECK_REQUEST_SUCCESS: "GET_EMERGENCY_CHECK_REQUEST_SUCCESS",
  GET_EMERGENCY_CHECK_REQUEST_FAILURE: "GET_EMERGENCY_CHECK_REQUEST_FAILURE",

  GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION:
    "GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION",
  GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_SUCCESS:
    "GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_SUCCESS",
  GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_FAILURE:
    "GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_FAILURE",

  SET_FIELD_VALUE_SELECTED_TEMPORARY_EMERGENCY_ABILITATION:
    "SET_FIELD_VALUE_SELECTED_TEMPORARY_EMERGENCY_ABILITATION",

  GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST:
    "GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST",
  GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS:
    "GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS",
  GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE:
    "GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE",

  SET_SELECTED_EMERGENCY_TEMPORARY_ABILITATION:
    "SET_SELECTED_EMERGENCY_TEMPORARY_ABILITATION",
};

export const getUserEntitlementForCheck = (payload: string) => ({
  type: actionTypes.GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST,
  payload,
});
export const getUserEntitlementForCheckSuccess = (payload: string) => ({
  type: actionTypes.GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST_SUCCESS,
  payload,
});
export const getUserEntitlementForCheckFailure = (payload: string) => ({
  type: actionTypes.GET_USER_ENTITLEMENTS_FOR_CHECK_REQUEST_FAILURE,
  payload,
});

export const temporaryAbilitationsFetchRequest = (payload: any) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST,
  payload,
});

export const temporaryAbilitationsFetchRequestSuccess = (payload: any) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS,
  payload,
});

export const temporaryAbilitationsFetchRequestFailure = (err: Error) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE,
  err,
});

export const emergencyTemporaryAbilitationsFetchRequest = (payload: any) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST,
  payload,
});

export const emergencyTemporaryAbilitationsFetchRequestSuccess = (
  payload: any
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS,
  payload,
});

export const emergencyTemporaryAbilitationsFetchRequestFailure = (
  err: Error
) => ({
  type: actionTypes.TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE,
  err,
});

export const setSelectedTemporaryAbilitation = (payload: any) => ({
  type: actionTypes.SET_SELECTED_TEMPORARY_ABILITATION,
  payload,
});

export const getFieldsSelectedTemporaryAbilitation = (payload: any) => ({
  type: actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION,
  payload,
});

export const getFieldsSelectedTemporaryAbilitationSuccess = (payload: any) => ({
  type: actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS,
  payload,
});

export const getFieldsSelectedTemporaryAbilitationFailure = (err: Error) => ({
  type: actionTypes.GET_FIELDS_SELECTED_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE,
  err,
});

export const getFieldsSelectedTemporaryEmergencyAbilitation = (
  payload: any
) => ({
  type: actionTypes.GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION,
  payload,
});

export const getFieldsSelectedTemporaryEmergencyAbilitationSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_SUCCESS,
  payload,
});

export const getFieldsSelectedTemporaryEmergencyAbilitationFailure = (
  err: Error
) => ({
  type: actionTypes.GET_FIELDS_SELECTED_TEMPORARY_EMERGENCY_ABILITATION_REQUEST_ACTION_FAILURE,
  err,
});

export const setFieldValueSelectedTemporaryAbilitation = (
  field: string,
  fieldValue: string
) => ({
  type: actionTypes.SET_FIELD_VALUE_SELECTED_TEMPORARY_ABILITATION,
  payload: { field, fieldValue },
});

export const setFieldValueSelectedTemporaryEmergencyAbilitation = (
  field: string,
  fieldValue: string
) => ({
  type: actionTypes.SET_FIELD_VALUE_SELECTED_TEMPORARY_EMERGENCY_ABILITATION,
  payload: { field, fieldValue },
});

export const sendTemporaryAbilitation = (payload: any) => ({
  type: actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION,
  payload,
});

export const sendTemporaryAbilitationSuccess = (payload: any) => ({
  type: actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_SUCCESS,
  payload,
});

export const sendTemporaryAbilitationFailure = (err: Error) => ({
  type: actionTypes.SEND_TEMPORARY_ABILITATION_REQUEST_ACTION_FAILURE,
  err,
});

export const checkRequirementEntitlementsAction = (payload: any) => ({
  type: actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS,
  payload,
});

export const checkRequirementEntitlementsActionSuccess = (payload: any) => ({
  type: actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS_SUCCESS,
  payload,
});

export const checkRequirementEntitlementsActionFailure = (err: Error) => ({
  type: actionTypes.CHECK_REQUIREMENT_ENTITLEMENTS_FAILURE,
  err,
});

export const getEmergencyCheckAction = (payload: any) => ({
  type: actionTypes.GET_EMERGENCY_CHECK_REQUEST,
  payload,
});

export const getEmergencyCheckActionSuccess = (payload: any) => ({
  type: actionTypes.GET_EMERGENCY_CHECK_REQUEST_SUCCESS,
  payload,
});

export const getEmergencyCheckActionFailure = (err: Error) => ({
  type: actionTypes.GET_EMERGENCY_CHECK_REQUEST_FAILURE,
  err,
});

export const getEmergencyTemporaryEntitlementsAction = (payload: any) => ({
  type: actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST,
  payload,
});

export const getEmergencyTemporaryEntitlementsActionSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_SUCCESS,
  payload,
});

export const getEmergencyTemporaryEntitlementsActionFailure = (err: Error) => ({
  type: actionTypes.GET_EMERGENCY_TEMPORARY_ABILITATIONS_FETCH_REQUEST_FAILURE,
  err,
});

export const setSelectedEmergencyTemporaryAbilitation = (payload: any) => ({
  type: actionTypes.SET_SELECTED_EMERGENCY_TEMPORARY_ABILITATION,
  payload,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE_TEMPORARY_ABILITATIONS,
});
